module.exports = __webpack_public_path__ + "img/layer-minus.6aba191d.svg";